import type { MidiaDaBibliotecaDto } from "@base/contracts";
import type { FiltroListarMidias } from "../infrastructure/midias.gateway";

export type FiltrosDaBiblioteca = {
  readonly q: string;
  readonly tipoArquivo: "" | "imagem" | "video";
  readonly origem: "" | "upload" | "publicacao";
  readonly soFavoritas: boolean;
  readonly ordenar: "recente" | "nome";
};

export const FILTROS_INICIAIS_DA_BIBLIOTECA: FiltrosDaBiblioteca = {
  q: "",
  tipoArquivo: "",
  origem: "",
  soFavoritas: false,
  ordenar: "recente",
};

export function ehVideoDaBiblioteca(item: MidiaDaBibliotecaDto): boolean {
  return item.mimeType.startsWith("video/");
}

export function rotuloDoTipo(item: MidiaDaBibliotecaDto): string {
  return ehVideoDaBiblioteca(item) ? "Vídeo" : "Imagem";
}

export function rotuloDaOrigem(item: MidiaDaBibliotecaDto): string {
  return item.origem === "publicacao" ? "Veio de um post" : "Enviado por você";
}

export function formatarTamanho(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toLocaleString("pt-BR", {
      maximumFractionDigits: 1,
    })} KB`;
  }
  return `${(bytes / (1024 * 1024)).toLocaleString("pt-BR", {
    maximumFractionDigits: 1,
  })} MB`;
}

export function formatarQuando(iso: string): string {
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return "";
  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(data);
}

export function formatarDuracao(segundos: number | null): string | null {
  if (segundos === null || segundos < 0) return null;
  const min = Math.floor(segundos / 60);
  const seg = segundos % 60;
  return `${min}:${seg.toString().padStart(2, "0")}`;
}

export function filtrosDaBibliotecaAtivos(f: FiltrosDaBiblioteca): boolean {
  return Boolean(
    f.q.trim() ||
      f.tipoArquivo ||
      f.origem ||
      f.soFavoritas ||
      f.ordenar !== "recente",
  );
}

export function toFiltroListarMidias(
  f: FiltrosDaBiblioteca,
): FiltroListarMidias {
  return {
    ...(f.q.trim() ? { q: f.q.trim() } : {}),
    ...(f.tipoArquivo ? { tipoArquivo: f.tipoArquivo } : {}),
    ...(f.origem ? { origem: f.origem } : {}),
    ...(f.soFavoritas ? { soFavoritas: true } : {}),
    ...(f.ordenar !== "recente" ? { ordenar: f.ordenar } : {}),
  };
}

export function textoDaContagem(quantidade: number): string {
  return quantidade === 1 ? "1 arquivo" : `${quantidade} arquivos`;
}
